import { EntityAction, EntityRawAction } from '../../../entity-actions/interfaces/entity-actions';

export type RawObjectKeys = {
  required_keys: string[];
} & {
  [key: string]: string | string[];
};

export type RawObject = {
  keys: RawObjectKeys;
  field_count: number;
  status: string;
  reason: string;
  id: string;
  load_mode: string;
  is_editable: boolean;
  actions?: EntityRawAction<ObjectConfigAction>[];
} & {
  [key: string]: string | RawObjectKeys | number | EntityRawAction<ObjectConfigAction>[] | boolean;
};

export interface ObjectsListRawData {
  data: RawObject[];
  limit: number;
  page: number;
  selected_count: number;
  total_count: number;
  disabled_count: number;
}

export type ObjectKeys = {
  requiredKeys: string[];
} & {
  [key: string]: string | string[];
};

export enum ObjectConfigStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED',
  INACCESSIBLE = 'INACCESSIBLE',
  INCONSISTENT = 'INCONSISTENT'
}

export enum ObjectConfigAction {
  TRUNCATE_AND_LOAD = 'TRUNCATE_AND_LOAD',
  EDIT_CONFIG = 'EDIT_CONFIG',
  VIEW_CONFIG = 'VIEW_CONFIG'
}

export type ObjectConfig = {
  id: string;
  loadMode: string;
  keys: ObjectKeys;
  status: ObjectConfigStatus;
  statusReason?: string;
  fieldCount: number;
  isEditable: boolean;
  isConfigurable: boolean;
  isEditConfigAllowed: boolean;
  actions: EntityAction<ObjectConfigAction>[];
} & {
  [key: string]: string | number | boolean | ObjectKeys | EntityAction<ObjectConfigAction>[];
};

export enum ObjectsConfigStatusEnum {
  REQUESTED = 'REQUESTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export interface ObjectsConfigStatus {
  status: ObjectsConfigStatusEnum;
  statusReason?: string;
}
